import { toast } from 'sonner';
import { api, ApiError } from '../../lib/api';

/** Rapor dosyasını (CSV/XLSX) indirir; hata olursa bildirim gösterir. */
export async function downloadReport(path: string, fallbackName: string): Promise<void> {
  try {
    const { blob, fileName } = await api.blob(path);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName ?? fallbackName;
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error(e instanceof ApiError ? e.title : String(e));
  }
}
